import React from 'react';
import PropTypes from 'prop-types';
import { TextArea } from '@vds/inputs';

const VDSTextArea = (props) => <TextArea {...props} />;

VDSTextArea.defaultProps = {
  error: false,
  onChange: () => {},
};

VDSTextArea.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  handleChangeEvent: PropTypes.func,
  width: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func,
};

export { VDSTextArea };
